"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataRequestSource = void 0;
var DataRequestSource;
(function (DataRequestSource) {
    DataRequestSource["DB"] = "db";
})(DataRequestSource = exports.DataRequestSource || (exports.DataRequestSource = {}));
